<div class="field-execution-container">

  <!-- 1. HEADER REDESIGN -->
  <header class="fe-header">
    <div class="fe-header-content">
      <div class="header-left">
        <button (click)="goBack()" class="back-pill-btn" title="Back">
          <i class="fa-solid fa-arrow-left"></i>
          <span>Back</span>
        </button>
        <div class="header-branding">
          <div class="helmet-icon-wrap">
            <i class="fa-solid fa-hard-hat"></i>
          </div>
          <div class="title-meta">
            <h1>Field Execution</h1>
            <p class="fe-desktop-only">MANAGE BLOCKS AND PROJECT EXECUTION</p>
            <p class="fe-mobile-only fe-mobile-block-name">
              @if (screen() === 'projects') {
                {{ villageLabel(selectedVillage()?.village || '') }} {{ gpLabel() }}
              } @else {
                {{ displayBlockName() }}
              }
            </p>
            <div class="breadcrumb fe-desktop-only">
              <span>Field Execution</span>
              <i class="fa-solid fa-chevron-right"></i>
              <span>{{displayBlockName()}}</span>
              <i class="fa-solid fa-chevron-right"></i>
              @if (screen() === 'projects') {
                <span class="active">{{villageLabel(selectedVillage()?.village || '')}} {{gpLabel()}}</span>
              } @else {
                <span class="active">{{gpLabelFull()}}s ({{gpLabelPlural()}})</span>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="header-actions">
        <button (click)="goHome()" class="action-btn-outline home-btn" title="Back to Home">
          <i class="fa-solid fa-house"></i>
          <span>Home</span>
        </button>
        <button (click)="doExport()" class="action-btn-outline export">
          <i class="fa-solid fa-file-export"></i>
          <span>Export</span>
        </button>
      </div>
    </div>
  </header>

  <!-- 2. FILTER TOOLBAR (villages screen only, desktop) -->
  @if (screen() === 'villages') {
  <div class="fe-toolbar-container fe-desktop-only">
    <div class="fe-toolbar">
      <div class="toolbar-left">
        <div class="search-box">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="search" [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)"
                 [placeholder]="'Search ' + gpLabel() + ' by name, project or scheme...'" />
        </div>
      </div>
      
      <div class="toolbar-center">
        <div class="status-badge delayed">
          <i class="status-dot red"></i> Delayed > 60 Days
        </div>
        <div class="status-badge low-prog">
          <i class="status-dot orange"></i> Low Progress < 30%
        </div>
      </div>

      <div class="toolbar-right">
        <div class="sort-dropdown">
          <span>Sort by:</span>
          <select>
            <option>Highest Delay</option>
            <option>Lowest PAI</option>
            <option>Alphabetical</option>
          </select>
        </div>
        <div class="update-info">
          <span>Last Updated: Today, {{ currentTime() | date:'shortTime' }}</span>
          <button class="refresh-btn"><i class="fa-solid fa-rotate"></i></button>
        </div>
      </div>
    </div>
  </div>
  } <!-- end toolbar @if -->

  @if (screen() === 'villages') {
    <!-- MOBILE: compact KPI grid -->
    <div class="fe-mobile-only fe-mobile-kpi">
      <div class="fe-kpi-row">
        <button type="button" class="fe-kpi-tile blue" (click)="openList('totalGPs')" [attr.aria-label]="'Total ' + gpLabelPlural()">
          <i class="fa-solid fa-location-dot"></i>
          <span class="fe-kpi-val">{{ filteredVillages().length }}</span>
        </button>
        <button type="button" class="fe-kpi-tile purple" (click)="openList('totalProjectsBlock')" aria-label="Total Projects">
          <i class="fa-solid fa-briefcase"></i>
          <span class="fe-kpi-val">{{ selectedBlock()?.totalProjects || 0 | number }}</span>
        </button>
        <button type="button" class="fe-kpi-tile cyan" (click)="openList('sanctionedBlock')" aria-label="Sanctioned Amount">
          <i class="fa-solid fa-indian-rupee-sign"></i>
          <span class="fe-kpi-val">{{ sanctionedCompact(selectedBlock()?.sanctionedAmount) }}</span>
        </button>
        <button type="button" class="fe-kpi-tile red" (click)="openList('stuckBlock')" aria-label="Stuck Projects">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span class="fe-kpi-val">{{ blockStuckNotStarted().count }}</span>
        </button>
      </div>
      <div class="fe-kpi-row">
        <button type="button" class="fe-kpi-tile green" (click)="openList('onTrackBlock')" aria-label="On Track">
          <i class="fa-solid fa-circle-check"></i>
          <span class="fe-kpi-val">{{ selectedBlock()?.onTrackCount || 0 }}</span>
        </button>
        <button type="button" class="fe-kpi-tile orange" (click)="openList('inProgressBlock')" aria-label="In Progress">
          <i class="fa-solid fa-clock"></i>
          <span class="fe-kpi-val">{{ selectedBlock()?.inProgressCount || 0 }}</span>
        </button>
        <button type="button" class="fe-kpi-tile navy" (click)="openList('avgProgressBlock')" aria-label="Average Progress">
          <i class="fa-solid fa-chart-line"></i>
          <span class="fe-kpi-val">{{ selectedBlock()?.avgProgress || 0 }}%</span>
        </button>
        <button type="button" class="fe-kpi-tile darkred" (click)="openList('delayedBlock')" aria-label="Delayed">
          <i class="fa-solid fa-rotate"></i>
          <span class="fe-kpi-val">{{ selectedBlock()?.delayedCount || 0 }}</span>
        </button>
      </div>
    </div>

    <!-- MOBILE: sticky GP search -->
    <div class="fe-mobile-only fe-mobile-search">
      <div class="fe-search-box">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="search"
               [placeholder]="'Search ' + gpLabel() + '…'"
               [ngModel]="searchTerm()"
               (ngModelChange)="searchTerm.set($event)"
               [attr.aria-label]="'Search ' + gpLabel()" />
        @if (searchTerm()) {
          <button type="button" class="fe-search-clear" (click)="searchTerm.set('')" aria-label="Clear search">
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </div>
    </div>

    <!-- 3. SUMMARY STATISTICS CARDS (desktop) -->
    <div class="stats-cards-row fe-desktop-only">
      <div class="stat-card blue fe-link" (click)="openList('totalGPs')">
        <div class="icon-circle"><i class="fa-solid fa-location-dot"></i></div>
        <div class="info">
          <p class="label">Block: {{displayBlockName()}}</p>
          <h2 class="value">{{filteredVillages().length}} <span class="perc">Total {{gpLabelPlural()}}</span></h2>
        </div>
      </div>
      <div class="stat-card purple fe-link" (click)="openList('totalProjectsBlock')">
        <div class="icon-circle"><i class="fa-solid fa-briefcase"></i></div>
        <div class="info">
          <p class="label">Total Projects</p>
          <h2 class="value">{{selectedBlock()?.totalProjects || 0 | number}}</h2>
        </div>
      </div>
      <div class="stat-card cyan fe-link" (click)="openList('sanctionedBlock')">
        <div class="icon-circle"><i class="fa-solid fa-indian-rupee-sign"></i></div>
        <div class="info">
          <p class="label">Sanctioned Amount</p>
          <h2 class="value">{{ formatCostLakh(selectedBlock()?.sanctionedAmount) }}</h2>
        </div>
      </div>
      <div class="stat-card green fe-link" (click)="openList('onTrackBlock')">
        <div class="icon-circle"><i class="fa-solid fa-circle-check"></i></div>
        <div class="info">
          <p class="label">On Track</p>
          <h2 class="value">{{selectedBlock()?.onTrackCount || 0}} <span class="perc">({{selectedBlock()?.onTrackPercent || 0}}%)</span></h2>
        </div>
      </div>
      <div class="stat-card orange fe-link" (click)="openList('inProgressBlock')">
        <div class="icon-circle"><i class="fa-solid fa-clock"></i></div>
        <div class="info">
          <p class="label">In Progress</p>
          <h2 class="value">{{selectedBlock()?.inProgressCount || 0}} <span class="perc">({{selectedBlock()?.inProgressPercent || 0}}%)</span></h2>
        </div>
      </div>
      <div class="stat-card red fe-link" (click)="openList('delayedBlock')">
        <div class="icon-circle"><i class="fa-solid fa-triangle-exclamation"></i></div>
        <div class="info">
          <p class="label">Delayed (>60 Days)</p>
          <h2 class="value">{{selectedBlock()?.delayedCount || 0}} <span class="perc">({{selectedBlock()?.delayedPercent || 0}}%)</span></h2>
        </div>
      </div>
      <div class="stat-card navy fe-link" (click)="openList('avgProgressBlock')">
        <div class="icon-circle"><i class="fa-solid fa-chart-line"></i></div>
        <div class="info">
          <p class="label">Avg. Progress</p>
          <h2 class="value">{{selectedBlock()?.avgProgress || 0}}%</h2>
        </div>
      </div>
      <div class="stat-card darkred fe-link" (click)="openList('stuckBlock')">
        <div class="icon-circle"><i class="fa-solid fa-circle-xmark"></i></div>
        <div class="info">
          <p class="label">Stuck / Not Started</p>
          <h2 class="value">{{ blockStuckNotStarted().count }} <span class="perc">({{ blockStuckNotStarted().percent }}%)</span></h2>
        </div>
      </div>
    </div>

    <!-- MOBILE: GP cards -->
    <div class="fe-mobile-only fe-mobile-gp-list">
      @if (isLoading()) {
        <div class="fe-mobile-loading">
          <i class="fa-solid fa-spinner fa-spin"></i>
          <p>Loading {{ gpLabelPlural() }}…</p>
        </div>
      } @else if (filteredVillages().length === 0) {
        <div class="fe-mobile-empty">
          <i class="fa-solid fa-filter-circle-xmark"></i>
          <p>No {{ gpLabelPlural() }} match your search.</p>
        </div>
      } @else {
        @for (v of filteredVillages(); track v.village) {
          <article class="fe-gp-card" (click)="selectVillage(v)">
            <div class="fe-gp-card-top">
              <div class="fe-gp-main">
                <h3 class="fe-gp-name">{{ villageLabel(v.village) }}</h3>
                <p class="fe-gp-sub">{{ v.totalProjects }} Projects</p>
              </div>
              <i class="fa-solid fa-chevron-right fe-gp-chevron" aria-hidden="true"></i>
            </div>
            <p class="fe-gp-amount">{{ formatCostLakh(v.sanctionedAmount) }}</p>
            <div class="fe-gp-progress">
              <span class="fe-gp-progress-lbl">Progress</span>
              <div class="fe-gp-progress-track">
                <div class="fe-gp-progress-fill"
                     [style.width.%]="v.avgProgress"
                     [class.low]="v.avgProgress < 30"
                     [class.mid]="v.avgProgress >= 30 && v.avgProgress < 70"
                     [class.high]="v.avgProgress >= 70"></div>
              </div>
              <span class="fe-gp-progress-pct">{{ v.avgProgress }}%</span>
            </div>
            <div class="fe-gp-stats">
              <span class="fe-gp-stat">Stuck {{ villageStuckNotStarted(v).count }}</span>
              <span class="fe-gp-stat">Track {{ v.onTrackCount }}</span>
              <span class="fe-gp-stat">Progress {{ v.inProgressCount }}</span>
            </div>
            <p class="fe-gp-updated">
              <span [class.today]="v.lastUpdated === 'Today'">{{ v.lastUpdated ?? '–' }}</span>
            </p>
          </article>
        }
      }
    </div>

    <!-- 4/5. MAIN GP EXECUTION TABLE (desktop) -->
    <div class="execution-table-wrapper fe-desktop-only">
      <table class="premium-execution-table">
        <thead>
          <tr>
            <th class="w-sl">#</th>
            <th>{{gpLabelFull()}} ({{gpLabel()}})</th>
            <th class="text-center">Total Projects</th>
            <th class="text-center">Sanctioned Amount (₹)</th>
            <th><i class="status-dot green"></i> On Track <span class="th-sub">(≥ 70%)</span></th>
            <th><i class="status-dot orange"></i> In Progress <span class="th-sub">(30% - 70%)</span></th>
            <th><i class="status-dot red"></i> Delayed <span class="th-sub">(> 60 Days)</span></th>
            <th class="text-center">Executant Status</th>
            <th><i class="status-dot darkred"></i> Stuck / Not Started</th>
            <th class="text-center">Last Updated</th>
            <th class="w-action"></th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading()) {
            <tr><td colspan="11" class="text-center py-10"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</td></tr>
          } @else {
            @for (v of filteredVillages(); track v.village; let i = $index) {
              <tr class="execution-row" (click)="selectVillage(v)">
                <td class="w-sl"><div class="sl-badge">{{i + 1}}</div></td>
                <td>
                  <div class="block-info-cell">
                    <div class="side-indicator" [class]="v.paiCategory.toLowerCase()"></div>
                    <div class="name-meta">
                      <span class="block-name">{{villageLabel(v.village)}}</span>
                      <span class="project-subtitle">{{v.totalProjects}} Projects</span>
                    </div>
                    @if (v.statusBadge === 'High Delay') {
                      <span class="status-pill high-delay">High Delay</span>
                    }
                  </div>
                </td>
                <td class="text-center font-bold">{{v.totalProjects}}</td>
                <td class="text-center font-bold">{{ formatCostLakh(v.sanctionedAmount) }}</td>
                <td>
                  <div class="prog-stack">
                    <span class="p-val">{{v.onTrackCount}} ({{v.onTrackPercent}}%)</span>
                    <div class="p-bar-track"><div class="p-bar-fill green" [style.width.%]="v.onTrackPercent"></div></div>
                  </div>
                </td>
                <td>
                  <div class="prog-stack">
                    <span class="p-val">{{v.inProgressCount}} ({{v.inProgressPercent}}%)</span>
                    <div class="p-bar-track"><div class="p-bar-fill orange" [style.width.%]="v.inProgressPercent"></div></div>
                  </div>
                </td>
                <td>
                  <div class="prog-stack">
                    <span class="p-val">{{v.delayedCount}} ({{v.delayedPercent}}%)</span>
                    <div class="p-bar-track"><div class="p-bar-fill red" [style.width.%]="v.delayedPercent"></div></div>
                  </div>
                </td>
                <td class="text-center">
                  @if (villageExecutantStatus(v).allAvailable) {
                    <span class="executant-status-pill available"><i class="fa-solid fa-circle-check"></i> All available</span>
                  } @else {
                    <span class="executant-status-pill missing"><i class="fa-solid fa-triangle-exclamation"></i> {{ villageExecutantStatus(v).missingCount }} not available</span>
                  }
                </td>
                <td>
                  <div class="prog-stack">
                    <span class="p-val">{{ villageStuckNotStarted(v).count }} ({{ villageStuckNotStarted(v).percent }}%)</span>
                    <div class="p-bar-track"><div class="p-bar-fill darkred" [style.width.%]="villageStuckNotStarted(v).percent"></div></div>
                  </div>
                </td>
                <td class="text-center">
                  <span class="last-updated-pill" [class.today]="v.lastUpdated === 'Today'">{{v.lastUpdated}}</span>
                </td>
                <td class="w-action"><button class="arrow-btn"><i class="fa-solid fa-chevron-right"></i></button></td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <!-- 9. BOTTOM INFO SECTION -->
    <div class="fe-footer-alert fe-desktop-only">
      <div class="alert-content">
        <i class="fa-solid fa-circle-info"></i>
        <span>Click on any {{gpLabel()}} to view project list and detailed status.</span>
      </div>
    </div>

    <!-- 10. PAI GUIDE SECTION -->
    <div class="pai-guide-grid fe-desktop-only">
      <div class="card pai-guide-card">
        <div class="card-header"><h4>PAI 2.0 Score Guide</h4></div>
        <div class="guide-steps">
          <div class="step"><span class="badge poor">0 - 40</span> <span>Poor</span></div>
          <div class="step"><span class="badge moderate">40 - 70</span> <span>Moderate</span></div>
          <div class="step"><span class="badge good">70 - 100</span> <span>Good</span></div>
        </div>
      </div>
      <div class="card pai-about-card">
        <div class="card-header"><h4>About PAI 2.0</h4></div>
        <p>Performance Assessment Index (PAI) measures outcomes across key indicators like infrastructure, health, education, and governance.</p>
      </div>
      <div class="card pai-filters-card">
        <div class="card-header"><h4>Quick Filters</h4></div>
        <div class="filter-actions">
          <button class="filter-btn"><i class="fa-solid fa-triangle-exclamation"></i> Low PAI < 40</button>
          <button class="filter-btn"><i class="fa-solid fa-chart-line"></i> High Investment + Low PAI</button>
        </div>
      </div>
    </div>
  }

  @if (screen() === 'projects') {

    <!-- MOBILE: compact filters -->
    <div class="fe-mobile-only gp-mobile-filters">
      <div class="fe-search-box">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="search"
               placeholder="Search GP…"
               [ngModel]="searchTerm()"
               (ngModelChange)="searchTerm.set($event)"
               aria-label="Search projects" />
        @if (searchTerm()) {
          <button type="button" class="fe-search-clear" (click)="searchTerm.set('')" aria-label="Clear">
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </div>
      <div class="gp-mobile-select-row">
        <select class="gp-mobile-select" [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)" aria-label="Status">
          <option value="">Status</option>
          <option value="Completed">On Track</option>
          <option value="In Progress">Work Started</option>
          <option value="Stuck">Delayed</option>
          <option value="Planned">Not Started</option>
        </select>
        @if (availableSchemes().length > 0) {
          <select class="gp-mobile-select" [ngModel]="schemeFilter()" (ngModelChange)="schemeFilter.set($event)" aria-label="Scheme">
            <option value="">Scheme</option>
            @for (s of availableSchemes(); track s) {
              <option [value]="s">{{ s }}</option>
            }
          </select>
        } @else {
          <select class="gp-mobile-select" disabled aria-label="Scheme">
            <option>Scheme</option>
          </select>
        }
      </div>
    </div>

    <!-- MOBILE: compact GP summary -->
    @if (gpSummary(); as sum) {
      <div class="fe-mobile-only gp-mobile-summary">
        <div class="gp-ms-title">
          <i class="fa-solid fa-building-columns"></i>
          <span>{{ villageLabel(selectedVillage()?.village || '') }} {{ gpLabel() }}</span>
        </div>
        <p class="gp-ms-count">{{ sum.total }} Projects</p>
        <p class="gp-ms-amount">{{ formatCostLakh(sum.totalCost) }}</p>
        <div class="gp-ms-grid">
          <button type="button" class="gp-ms-cell track" (click)="openList('onTrackGP')">
            <span class="gp-ms-val">{{ sum.onTrack }}</span>
            <span class="gp-ms-lbl">Track</span>
          </button>
          <button type="button" class="gp-ms-cell prog" (click)="openList('inProgressGP')">
            <span class="gp-ms-val">{{ sum.inProgress }}</span>
            <span class="gp-ms-lbl">Progress</span>
          </button>
          <button type="button" class="gp-ms-cell delay" (click)="openList('delayedGP')">
            <span class="gp-ms-val">{{ sum.delayed }}</span>
            <span class="gp-ms-lbl">Delay</span>
          </button>
          <button type="button" class="gp-ms-cell stuck" (click)="openList('stuckGP')">
            <span class="gp-ms-val">{{ sum.stuckOrNS }}</span>
            <span class="gp-ms-lbl">Stuck</span>
          </button>
        </div>
        <p class="gp-ms-updated">
          Updated Today
          <button type="button" class="gp-ms-refresh" aria-label="Refresh">
            <i class="fa-solid fa-rotate"></i>
          </button>
        </p>
      </div>
    }

    <!-- MOBILE: projects list header -->
    <div class="fe-mobile-only gp-mobile-projects-head">
      <h3>Projects ({{ filteredProjectsFull().length }})</h3>
      <select class="gp-mobile-sort"
              [ngModel]="projectSortBy()"
              (ngModelChange)="setProjectSort($event)"
              aria-label="Sort projects">
        <option value="criticality">Sort ▼</option>
        <option value="alphabetical">A → Z</option>
        <option value="cost">Cost ↓</option>
      </select>
    </div>

    <!-- MOBILE: project cards -->
    <div class="fe-mobile-only gp-mobile-project-list">
      @if (isLoading()) {
        <div class="fe-mobile-loading"><i class="fa-solid fa-spinner fa-spin"></i><p>Loading projects…</p></div>
      } @else if (sortedProjectsForView().length === 0) {
        <div class="fe-mobile-empty"><i class="fa-solid fa-folder-open"></i><p>No projects found.</p></div>
      } @else {
        @for (p of sortedProjectsForView(); track p.id) {
          <article class="gp-proj-card">
            <h4 class="gp-proj-name">{{ p.name }}</h4>
            <p class="gp-proj-meta">
              <i class="fa-solid fa-location-dot"></i>
              {{ p.loc || p.village || '–' }}
            </p>
            @if (p.scheme) {
              <p class="gp-proj-meta scheme">
                <i class="fa-solid fa-tag"></i>
                {{ p.scheme }}
              </p>
            }
            <p class="gp-proj-cost">₹{{ p.cost | number:'1.2-2' }}L</p>
            @if (getExecutantDisplayName(p)) {
              <button type="button"
                      class="gp-proj-exec-link"
                      [class.duplicate-executant]="isDuplicateExecutant(p)"
                      (click)="$event.stopPropagation(); navigateToExecutant(p)">
                <i class="fa-solid fa-user-tie"></i>
                {{ getExecutantDisplayName(p) }}
              </button>
            }
            @if (p.executorNumber) {
              <p class="gp-proj-meta phone">
                <i class="fa-solid fa-phone"></i>
                {{ p.executorNumber }}
              </p>
            }
            <span class="gp-proj-status" [ngClass]="statusChipClass(p.status)">
              {{ statusLabel(p.status) }}
            </span>

            @if (editingProjectId() === p.id) {
              <form [formGroup]="editForm" class="gp-proj-edit" (ngSubmit)="saveEdit(p.id)">
                <div class="gp-edit-fields">
                  <div class="gp-edit-field">
                    <label>Executant Name</label>
                    <input formControlName="executorName" type="text" />
                  </div>
                  <div class="gp-edit-field">
                    <label>Phone</label>
                    <input formControlName="executorNumber" type="text" maxlength="15" />
                  </div>
                  <div class="gp-edit-field gp-edit-field-sm">
                    <label>Est. Cost (₹ L)</label>
                    <input formControlName="cost" type="number" min="0" step="0.01" placeholder="0.00" />
                  </div>
                  <div class="gp-edit-field gp-edit-field-sm">
                    <label>Status</label>
                    <select formControlName="status">
                      @for (s of statusOptions; track s) {
                        @if (s) { <option [value]="s">{{ statusLabel(s) }}</option> }
                      }
                    </select>
                  </div>
                  <div class="gp-edit-field gp-edit-field-sm">
                    <label>Progress %</label>
                    <input formControlName="physical" type="number" min="0" max="100" />
                  </div>
                </div>
                @if (saveError()) {
                  <div class="gp-edit-error">{{ saveError() }}</div>
                }
                <div class="gp-edit-actions">
                  <button type="submit" class="gp-save-btn" [disabled]="isSaving()">Save</button>
                  <button type="button" class="gp-cancel-btn" (click)="cancelEdit()">Cancel</button>
                </div>
              </form>
            }
          </article>
        }
      }
    </div>

    <!-- GP FILTER BAR (desktop) -->
    <div class="gp-filter-bar fe-desktop-only">
      <div class="gp-filter-left">
        <div class="gp-search-box">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="search" placeholder="Search by project name, scheme or executant..."
                 [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)" />
        </div>
        <select class="gp-status-select" [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)">
          <option value="">All Status</option>
          <option value="Completed">On Track</option>
          <option value="In Progress">Work Started</option>
          <option value="Stuck">Delayed</option>
          <option value="Planned">Not Started</option>
        </select>
        @if (availableSchemes().length > 0) {
          <select class="gp-status-select" [ngModel]="schemeFilter()" (ngModelChange)="schemeFilter.set($event)">
            <option value="">All Schemes</option>
            @for (s of availableSchemes(); track s) {
              <option [value]="s">{{ s }}</option>
            }
          </select>
        }
        @if (availableYears().length > 0) {
          <select class="gp-status-select" [ngModel]="yearFilter()" (ngModelChange)="yearFilter.set($event)">
            <option value="">All Years</option>
            @for (y of availableYears(); track y) {
              <option [value]="y">{{ y }}</option>
            }
          </select>
        }
      </div>
      <div class="gp-filter-chips">
        <button class="gp-chip" [class.gp-chip-active]="activeQuickFilter() === 'delayed'"
                (click)="setQuickFilter('delayed')">
          <i class="fa-solid fa-circle-xmark gp-chip-icon red"></i> Delayed
        </button>
        <button class="gp-chip" [class.gp-chip-active]="activeQuickFilter() === 'stuck-ns'"
                (click)="setQuickFilter('stuck-ns')">
          <i class="fa-solid fa-circle-xmark gp-chip-icon orange"></i> Stuck / Not Started
        </button>
      </div>
    </div>

    <!-- GP SUMMARY CARD (desktop) -->
    <div class="gp-summary-wrap fe-desktop-only">
      <div class="gp-summary-card">
        <div class="gp-summary-header">
          <div class="gp-title-block">
            <div class="gp-icon-circle">
              <i class="fa-solid fa-building-columns"></i>
            </div>
            <div>
              <h2 class="gp-summary-title">{{villageLabel(selectedVillage()?.village || '')}} {{gpLabel()}} – Project Summary</h2>
            </div>
          </div>
          <div class="gp-last-updated">
            Last Updated: Today, {{ currentTime() | date:'shortTime' }}
            <button class="gp-refresh-btn"><i class="fa-solid fa-rotate"></i></button>
          </div>
        </div>
        <div class="gp-summary-stats">
          <div class="gp-stat fe-link" (click)="openList('totalProjectsGP')">
            <div class="gp-stat-icon blue-bg"><i class="fa-solid fa-building-columns"></i></div>
            <div class="gp-stat-info">
              <div class="gp-stat-label">Total Projects</div>
              <div class="gp-stat-value">{{gpSummary()?.total}}</div>
            </div>
          </div>
          <div class="gp-stat-divider"></div>
          <div class="gp-stat fe-link" (click)="openList('totalCostGP')">
            <div class="gp-stat-icon purple-bg"><i class="fa-solid fa-indian-rupee-sign"></i></div>
            <div class="gp-stat-info">
              <div class="gp-stat-label">Total Est. Cost</div>
              <div class="gp-stat-value">{{ formatCostLakh(gpSummary()?.totalCost) }}</div>
            </div>
          </div>
          <div class="gp-stat-divider"></div>
          <div class="gp-stat fe-link" (click)="openList('onTrackGP')">
            <div class="gp-stat-icon green-bg"><i class="fa-solid fa-circle-check"></i></div>
            <div class="gp-stat-info">
              <div class="gp-stat-label">On Track</div>
              <div class="gp-stat-value">
                {{gpSummary()?.onTrack}}
                <span class="gp-stat-pct">({{gpSummary()?.total ? ((gpSummary()!.onTrack / gpSummary()!.total) * 100 | number:'1.0-0') : 0}}%)</span>
              </div>
            </div>
          </div>
          <div class="gp-stat-divider"></div>
          <div class="gp-stat fe-link" (click)="openList('inProgressGP')">
            <div class="gp-stat-icon amber-bg"><i class="fa-regular fa-clock"></i></div>
            <div class="gp-stat-info">
              <div class="gp-stat-label">In Progress</div>
              <div class="gp-stat-value">
                {{gpSummary()?.inProgress}}
                <span class="gp-stat-pct">({{gpSummary()?.total ? ((gpSummary()!.inProgress / gpSummary()!.total) * 100 | number:'1.0-0') : 0}}%)</span>
              </div>
            </div>
          </div>
          <div class="gp-stat-divider"></div>
          <div class="gp-stat fe-link" (click)="openList('delayedGP')">
            <div class="gp-stat-icon red-bg"><i class="fa-solid fa-triangle-exclamation"></i></div>
            <div class="gp-stat-info">
              <div class="gp-stat-label">Delayed</div>
              <div class="gp-stat-value">
                {{gpSummary()?.delayed}}
                <span class="gp-stat-pct">({{gpSummary()?.total ? ((gpSummary()!.delayed / gpSummary()!.total) * 100 | number:'1.0-0') : 0}}%)</span>
              </div>
            </div>
          </div>
          <div class="gp-stat-divider"></div>
          <div class="gp-stat fe-link" (click)="openList('stuckGP')">
            <div class="gp-stat-icon darkred-bg"><i class="fa-solid fa-circle-xmark"></i></div>
            <div class="gp-stat-info">
              <div class="gp-stat-label">Stuck / Not Started</div>
              <div class="gp-stat-value">
                {{gpSummary()?.stuckOrNS}}
                <span class="gp-stat-pct">({{gpSummary()?.total ? ((gpSummary()!.stuckOrNS / gpSummary()!.total) * 100 | number:'1.0-0') : 0}}%)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- GP PROJECTS TABLE (desktop) -->
    <div class="gp-table-section fe-desktop-only">
      <div class="gp-table-header">
        <h3 class="gp-table-title">Projects of {{villageLabel(selectedVillage()?.village || '')}} {{gpLabel()}} ({{filteredProjectsFull().length}})</h3>
        <div class="gp-table-sort">
          <span>Sort by:</span>
          <select class="gp-sort-select"
                  [ngModel]="projectSortBy()"
                  (ngModelChange)="setProjectSort($event)"
                  aria-label="Sort projects">
            <option value="criticality">Criticality (High → Low)</option>
            <option value="alphabetical">Alphabetical</option>
            <option value="cost">Cost (High → Low)</option>
          </select>
        </div>
      </div>

      <div class="gp-table-wrapper">
        <table class="gp-projects-table">
          <thead>
            <tr>
              <th class="th-sl">SL</th>
              <th class="th-village th-sortable" (click)="toggleTableSort('village')">
                Village <i class="fa-solid" [ngClass]="tableSortIcon('village')" [class.th-sort-active]="tableSortKey() === 'village'"></i>
              </th>
              <th class="th-scheme th-sortable" (click)="toggleTableSort('scheme')">
                Scheme <i class="fa-solid" [ngClass]="tableSortIcon('scheme')" [class.th-sort-active]="tableSortKey() === 'scheme'"></i>
              </th>
              <th class="th-project th-sortable" (click)="toggleTableSort('name')">
                Project Name <i class="fa-solid" [ngClass]="tableSortIcon('name')" [class.th-sort-active]="tableSortKey() === 'name'"></i>
              </th>
              <th class="th-cost th-sortable" (click)="toggleTableSort('cost')">
                Est. Cost (₹) <i class="fa-solid" [ngClass]="tableSortIcon('cost')" [class.th-sort-active]="tableSortKey() === 'cost'"></i>
              </th>
              <th class="th-executant th-sortable" (click)="toggleTableSort('executant')">
                Executant Name<span class="req-star">*</span> <i class="fa-solid" [ngClass]="tableSortIcon('executant')" [class.th-sort-active]="tableSortKey() === 'executant'"></i>
                <span class="th-sub">(Type)</span>
                @if (hasMissingExecutants()) {
                  <label class="th-missing-toggle" (click)="$event.stopPropagation()" title="Show projects missing executant name or contact first">
                    <input type="checkbox"
                           [ngModel]="missingExecutantFirst()"
                           (ngModelChange)="missingExecutantFirst.set($event)" />
                    Not provided first
                  </label>
                }
              </th>
              <th class="th-contact th-sortable" (click)="toggleTableSort('contact')">
                Contact<span class="req-star">*</span> <i class="fa-solid" [ngClass]="tableSortIcon('contact')" [class.th-sort-active]="tableSortKey() === 'contact'"></i>
                <span class="th-sub">(Phone)</span>
                @if (hasMissingContacts()) {
                  <label class="th-missing-toggle" (click)="$event.stopPropagation()" title="Show projects missing executant name or contact first">
                    <input type="checkbox"
                           [ngModel]="missingContactFirst()"
                           (ngModelChange)="missingContactFirst.set($event)" />
                    Not provided first
                  </label>
                }
              </th>
              <th class="th-status th-sortable" (click)="toggleTableSort('status')">
                Status <i class="fa-solid" [ngClass]="tableSortIcon('status')" [class.th-sort-active]="tableSortKey() === 'status'"></i>
              </th>
              <th class="th-edit"></th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading()) {
              <tr><td colspan="9" class="gp-cell-center"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</td></tr>
            } @else if (filteredProjectsFull().length === 0) {
              <tr><td colspan="9" class="gp-cell-center">No projects found.</td></tr>
            } @else {
              @for (p of sortedProjectsForTable(); let i = $index; track p.id) {
                <tr class="gp-project-row" [ngClass]="rowBorderClass(p.status)" [class.gp-row-editing]="editingProjectId() === p.id">
                  <td class="td-sl">{{i + 1}}</td>
                  <td class="td-village" data-label="Village">{{p.loc || p.village || '–'}}</td>
                  <td class="td-scheme" data-label="Scheme">{{p.scheme || '–'}}</td>
                  <td class="td-project">{{p.name}}</td>
                  <td class="td-cost" data-label="Est. Cost">₹{{p.cost | number:'1.2-2'}} L</td>
                  <td class="td-executant" data-label="Executant">
                    @if (getExecutantDisplayName(p)) {
                      <span class="executant-name-link"
                            [class.duplicate-executant]="isDuplicateExecutant(p)"
                            [title]="getExecutantDisplayName(p)"
                            (click)="$event.stopPropagation(); navigateToExecutant(p)">
                        {{getExecutantDisplayName(p)}}
                      </span>
                      @if (getExecutantType(p)) {
                        <br><span class="executant-type-tag">({{getExecutantType(p)}})</span>
                      }
                    } @else {
                      <span class="gp-add-executant" (click)="$event.stopPropagation(); openEdit(p)">
                        <i class="fa-solid fa-plus"></i> Add
                      </span>
                    }
                  </td>
                  <td class="td-contact" data-label="Contact">
                    @if (p.executorNumber) {
                      <span class="contact-number">{{p.executorNumber}}</span>
                    } @else {
                      <span class="gp-add-executant" (click)="$event.stopPropagation(); openEdit(p)">
                        <i class="fa-solid fa-plus"></i> Add
                      </span>
                    }
                  </td>
                  <td class="td-status" data-label="Status">
                    <span class="status-chip-gp" [ngClass]="statusChipClass(p.status)">
                      @if (p.status === 'Completed') {
                        <i class="fa-solid fa-circle-check"></i>
                      } @else if (p.status === 'In Progress') {
                        <i class="fa-regular fa-clock"></i>
                      } @else if (p.status === 'Stuck') {
                        <i class="fa-solid fa-circle-xmark"></i>
                      } @else {
                        <i class="fa-regular fa-circle"></i>
                      }
                      {{statusLabel(p.status)}}
                    </span>
                  </td>
                  <td class="td-edit">
                    <button class="gp-edit-btn" (click)="$event.stopPropagation(); openEdit(p)"
                            [title]="editingProjectId() === p.id ? 'Editing…' : 'Edit executant / status'">
                      <i class="fa-solid" [class.fa-pencil]="editingProjectId() !== p.id" [class.fa-spinner]="editingProjectId() === p.id && isSaving()" [class.fa-xmark]="editingProjectId() === p.id && !isSaving()"></i>
                    </button>
                  </td>
                </tr>

                <!-- INLINE EDIT ROW -->
                @if (editingProjectId() === p.id) {
                  <tr class="gp-edit-row">
                    <td colspan="9">
                      <form [formGroup]="editForm" class="gp-edit-form" (ngSubmit)="saveEdit(p.id)">
                        <div class="gp-edit-fields">
                          <div class="gp-edit-field">
                            <label>Executant Name</label>
                            <input formControlName="executorName" type="text" placeholder="e.g. Ramesh Kumar / GP Committee" />
                          </div>
                          <div class="gp-edit-field">
                            <label>Phone / Contact</label>
                            <input formControlName="executorNumber" type="text" placeholder="e.g. 9937602928" maxlength="15" />
                          </div>
                          <div class="gp-edit-field gp-edit-field-sm">
                            <label>Est. Cost (₹ L)</label>
                            <input formControlName="cost" type="number" min="0" step="0.01" placeholder="0.00" />
                          </div>
                          <div class="gp-edit-field gp-edit-field-sm">
                            <label>Status</label>
                            <select formControlName="status">
                              @for (s of statusOptions; track s) {
                                @if (s) { <option [value]="s">{{statusLabel(s)}}</option> }
                              }
                            </select>
                          </div>
                          <div class="gp-edit-field gp-edit-field-sm">
                            <label>Progress (%)</label>
                            <input formControlName="physical" type="number" min="0" max="100" placeholder="0–100" />
                          </div>
                          <div class="gp-edit-field gp-edit-field-lg">
                            <label>Remarks</label>
                            <input formControlName="remarks" type="text" placeholder="Optional remarks..." />
                          </div>
                        </div>
                        @if (saveError()) {
                          <div class="gp-edit-error"><i class="fa-solid fa-circle-exclamation"></i> {{saveError()}}</div>
                        }
                        <div class="gp-edit-actions">
                          <button type="submit" class="gp-save-btn" [disabled]="isSaving()">
                            @if (isSaving()) { <i class="fa-solid fa-spinner fa-spin"></i> Saving… }
                            @else { <i class="fa-solid fa-check"></i> Save }
                          </button>
                          <button type="button" class="gp-cancel-btn" (click)="cancelEdit()">
                            <i class="fa-solid fa-xmark"></i> Cancel
                          </button>
                        </div>
                      </form>
                    </td>
                  </tr>
                }
              }
            }
          </tbody>
          @if (filteredProjectsFull().length > 0) {
            <tfoot>
              <tr class="gp-table-total-row">
                <td colspan="4" class="gp-table-total-label">Total Est. Cost</td>
                <td class="td-cost gp-table-total-value">{{ formatCostLakh(gpTableTotalCost()) }}</td>
                <td colspan="4"></td>
              </tr>
            </tfoot>
          }
        </table>
      </div>
    </div>

    <!-- FOOTER GUIDES (desktop) -->
    <div class="gp-guide-footer fe-desktop-only">
      <div class="guide-col">
        <span class="guide-title">Status Guide</span>
        <div class="guide-items">
          <span class="guide-item"><i class="fa-solid fa-circle-check g-green"></i> On Track</span>
          <span class="guide-item"><i class="fa-regular fa-clock g-amber"></i> Work Started</span>
          <span class="guide-item"><i class="fa-solid fa-circle-xmark g-red"></i> Delayed</span>
          <span class="guide-item"><i class="fa-regular fa-circle g-slate"></i> Not Started</span>
        </div>
      </div>
    </div>

  }

  <!-- DYNAMIC LIST MODAL -->
  @if (listFilter()) {
    <div class="fe-modal-overlay" (click)="closeList()">
      <div class="fe-modal-card" (click)="$event.stopPropagation()">
        <div class="fe-modal-header">
          <div>
            <h3>{{ listTitle() }}</h3>
            <p>{{ listShowsVillages() ? listVillages().length + ' ' + gpLabel() + '(s)' : listProjects().length + ' project(s)' }}</p>
          </div>
          <button class="fe-modal-close" (click)="closeList()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="fe-modal-body">
          @if (listShowsVillages()) {
            @if (listVillages().length === 0) {
              <div class="fe-empty"><i class="fa-solid fa-circle-check"></i><p>No {{gpLabelPlural()}} to show.</p></div>
            } @else {
              <table class="fe-modal-table">
                <thead>
                  <tr>
                    <th>{{gpLabelFull()}}</th>
                    <th class="text-center">Projects</th>
                    <th class="text-center">On Track</th>
                    <th class="text-center">Delayed</th>
                    <th class="text-center">Avg. Progress</th>
                    <th class="text-center">Stuck / Not Started</th>
                  </tr>
                </thead>
                <tbody>
                  @for (v of listVillages(); track v.village) {
                    <tr (click)="selectVillage(v); closeList()">
                      <td>{{ v.village }}</td>
                      <td class="text-center">{{ v.totalProjects }}</td>
                      <td class="text-center">{{ v.onTrackCount }} ({{ v.onTrackPercent }}%)</td>
                      <td class="text-center">{{ v.delayedCount }} ({{ v.delayedPercent }}%)</td>
                      <td class="text-center">{{ v.avgProgress }}%</td>
                      <td class="text-center">{{ villageStuckNotStarted(v).count }} ({{ villageStuckNotStarted(v).percent }}%)</td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          } @else {
            @if (listProjects().length === 0) {
              <div class="fe-empty"><i class="fa-solid fa-circle-check"></i><p>No matching projects.</p></div>
            } @else {
              <table class="fe-modal-table">
                <thead>
                  <tr>
                    <th>Project</th>
                    <th>Village</th>
                    <th>Scheme</th>
                    <th>Status</th>
                    <th class="text-center">Progress</th>
                    <th class="text-right">Cost (₹L)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (p of listProjects(); track p.id) {
                    <tr>
                      <td>{{ p.name }}</td>
                      <td>{{ p.village || p.loc || '–' }}</td>
                      <td>{{ p.scheme || '–' }}</td>
                      <td>
                        <span class="status-pill"
                              [class.stuck]="p.status === 'Stuck'"
                              [class.completed]="p.status === 'Completed'"
                              [class.inprogress]="p.status === 'In Progress'"
                              [class.planned]="p.status === 'Planned'">{{ statusLabel(p.status) }}</span>
                      </td>
                      <td class="text-center">{{ p.physical || 0 }}%</td>
                      <td class="text-right">{{ p.cost | number }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          }
        </div>

        <div class="fe-modal-footer">
          <button class="fe-btn-cancel" (click)="closeList()">Close</button>
        </div>
      </div>
    </div>
  }

</div>
